import script from "./product-bis.vue?vue&type=script&setup=props&lang=js"
export * from "./product-bis.vue?vue&type=script&setup=props&lang=js"

const __exports__ = script;

export default __exports__